var map = {
	"./1- State Level Award by Honorable State Minister of AP.jpeg": 13321,
	"./10- Book Launching by Commissioner of Police.jpeg": 91432,
	"./11- Youth Wing Launching by Honorable Commissioner of Police President Consumer Commission ACP.jpeg": 50129,
	"./2- State level Award by Honorable Collector of Visakhapatnam Govt. of AP.jpeg": 40370,
	"./3- Awarded as Best Consumer Activist at New Delhi on World Consumer Day - 2021.jpeg": 44785,
	"./4- Awarded as Best Consumer Activist at New Delhi on World Consumer Day - 2020.jpeg": 55049,
	"./5- Awarded as Best Consumer Activist at New Delhi on World Consumer Day - 2022.jpeg": 24510,
	"./6- Awarded by Honorable P.V. Sindhu.jpeg": 40917,
	"./7- Awarded as Best Consumer Activist  by Cine star Shri Suman Ji, Honorable MLA & Honorable ACP.jpeg": 34444,
	"./8- Awarded as Best Consumer Activist  by Cinestar Shri Rajendra Prasad Ji & Honorable President of DCDRC.jpeg": 29190,
	"./9- Awarded as Best Consumer Activist  by Honorable MLA.jpeg": 35760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50476;